export default __webpack_public_path__ + "device_doorbell_gen_2.064b5677.png";